

export default {
  getRevenueData: '/api/revenueApi/getRevenueData',
    getRevenueTableData: '/api/revenueApi/getRevenueTableData',
    getPublisherApp: '/api/revenueApi/getPublisherApp',
    allowAdvertiserReportUrl: '/api/revenueApi/getAllowAdvertiserReport'
}



// WEBPACK FOOTER //
// ./src/urls/revenueUrls.js